import React from 'react'
import AboutOverview from './about-components/aboutOverview'
import VisonMission from './about-components/vision&misssion'
import MeetOurFounders from './about-components/meet-our-founder'
import AwardsRecognition from './about-components/awards&recognition'
import CustomerRelationship from './about-components/customer-relationship'
import Partnership from './about-components/partnership'
import AppreciationLetter from './about-components/appreciation-letters'
import Navbar from '../components/navbar'
import FooterAll from '../components/footer2'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
function AboutUs() {
    const canonical = window.location.href.replace(/^https?:\/\/www\./, 'https://');

    return (
        <div>
            <Navbar />

            <Helmet>
                <title>Saya Homes | Top Real Estate Builders in Noida, Greater Noida & Ghaziabad</title>
                <meta name="description" content="Saya Homes is a ranked among top real estate builders in Noida, offering luxury residential and commercial property in Noida, Greater Noida and Ghaziabad." />
                <meta name="keywords" content="saya homes, builders in noida, builders in greater noida, top real estate builders in noida, best real estate builder in noida, luxury real estate builder in noida" />
                <link rel="canonical" href={canonical}/></Helmet>
            <div>
                <div className="emptyBox"></div>
                <div className="pageTitle py-5 bg-orange w-100">
                    <div className="container-lg">
                        <h1 className="display-4 mb-0">About Us</h1>
                    </div>
                </div>
                <div className="breadcrumbContainer">
                    <div className="container-lg">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to='/'>Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">About Us</li>
                        </ol>
                    </div>
                </div>
                <AboutOverview />
                <VisonMission />
                <MeetOurFounders />
                <AwardsRecognition />


            </div >
            <div className="w-100 padding position-relative animate-section5">

                <div className="container-lg">
                    <div className="heading">
                        <h2 className="h1 text-serif mb-0">Saya - With You, Always!</h2>
                    </div>
                    <div className="row gap-row">
                        <div className="col-lg-4 col-md-6 with-you-box">
                            <div className="inner">
                                <span className="line-plus"></span>
                                <h4 className="smallHeading text-serif">Timely Delivery</h4>
                                <p className="mb-0">Timely delivery is not a choice but a requisite for a property buyer. At Saya, we ensure that every project is delivered on time and without any compromises.</p>
                            </div>
                            <div className="with-img" style={{ backgroundImage: "url(https://sayahomes.com/assets/images/Assurance-of-Delivery.webp)" }}></div>
                        </div>
                        <div className="col-lg-4 col-md-6 with-you-box">
                            <div className="inner">
                                <span className="line-plus"></span>
                                <h4 className="smallHeading text-serif">High on Quality</h4>
                                <p className="mb-0">We take pride in delivering quality through the amalgamation of years of experience and new-age methodologies.Over the years, we have evolved the multi-point quality check systems for sustainable living.</p>
                            </div>
                            <div className="with-img" style={{ backgroundImage: "url(https://sayahomes.com/assets/images/High-Quality.webp)" }}></div>
                        </div>
                        <div className="col-lg-4 col-md-6 with-you-box">
                            <div className="inner">
                                <span className="line-plus"></span>
                                <h4 className="smallHeading text-serif">Embrace Your Green Side</h4>
                                <p className="mb-0">It’s a human tendency to strive towards and greener and sustainable lifestyle and we truly understand it.</p>
                            </div>
                            <div className="with-img" style={{ backgroundImage: "url(https://sayahomes.com/assets/images/Eco-friendly.webp)" }}></div>
                        </div>
                        <div className="col-lg-4 col-md-6 with-you-box">
                            <div className="inner">
                                <span className="line-plus"></span>
                                <h4 className="smallHeading text-serif">Innovating the Future</h4>
                                <p className="mb-0">Innovation is paramount for the growth of an organization. At Saya, we innovate and inculcate the latest technology because our customers deserve the best, every day.</p>
                            </div>
                            <div className="with-img" style={{ backgroundImage: "url(https://sayahomes.com/assets/images/Transparent-Timely.webp)" }}></div>
                        </div>
                        <div className="col-lg-8 col-md-6 with-you-box">
                            <div className="inner">
                                <span className="line-plus"></span>
                                <h4 className="smallHeading text-serif">Transparency. Trust. Timely Deliveries.</h4>
                                <p className="mb-0">Transparency and complete honesty at every procedural step is important for every real-estate builder. We ensure timely updates of all our projects and make sure that every customer who places their trust in us is not disappointed.</p>
                            </div>
                            <div className="with-img" style={{ backgroundImage: "url(https://sayahomes.com/assets/images/Handover.webp)" }}></div>
                        </div>
                    </div>
                </div>
            </div>
            <CustomerRelationship />
            <Partnership />
            <AppreciationLetter />
            <FooterAll />


        </div>
    )
}

export default AboutUs